import { useTranslation } from "react-i18next";

import { AXON_SITE_URL } from "../constants";
import { IconButton } from "./IconButton";
import { InguzMark } from "./InguzMark";
import { LanguageSwitcher } from "./LanguageSwitcher";

interface Props {
  onShare: () => void;
  onAbout: () => void;
  onFeedback?: () => void;
}

export function WorkspaceHeader({ onShare, onAbout, onFeedback }: Props) {
  const { t } = useTranslation("common");

  return (
    <header
      role="banner"
      className="h-header px-3 flex items-center justify-between bg-surface-subtle/50 border-b border-border-subtle shrink-0"
    >
      <a
        href={AXON_SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-text-main"
        aria-label="Axon Group"
      >
        <InguzMark size={22} />
        <span className="font-sans font-bold uppercase tracking-wider text-text-main text-[14px] leading-[19px]">
          {t("brand")}
        </span>
      </a>

      <div
        role="toolbar"
        aria-label={t("header.actions.more")}
        className="flex items-center gap-1"
      >
        <IconButton icon="share" label={t("header.actions.share")} onClick={onShare} />
        <IconButton
          icon="feedback"
          label={t("header.actions.feedback")}
          onClick={onFeedback}
          disabled={!onFeedback}
        />
        <IconButton icon="info" label={t("header.actions.about")} onClick={onAbout} />
        <LanguageSwitcher />
      </div>
    </header>
  );
}
